// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"e29f2309","148":"93cb2c1b","163":"7de24743","275":"e7266003","787":"d5991193","788":"9d117e42","898":"b0640873","945":"10ce6d5b"}[chunkId] + ".chunk.js";
};